export const validate = (value, validations) => {
  let error = null;
  if (!validations) return { error };
  for (let validation of validations) {
    error = error ? error : valid[validation](value);
  }

  return { error };
};

const isEmail = value => {
  const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  if (!value || regex.test(value)) {
    return null;
  }

  return "Please provide valid e-mail.";
};

const isOnlyText = value => {
  const regex = /^[a-zA-Z. \u0600-\u06FF]*$/;
  if (!value || regex.test(value)) {
    return null;
  }

  return "Valid characters are A-z.";
};

const isOnlyNumbers = value => {
  const regex = /^\d+$/;
  if (!value || regex.test(value)) {
    return null;
  }

  return "Valid characters include 0-9.";
};

const isOnlyNumbersAndLatters = value => {
  const regex = /^[a-zA-Z. \u0600-\u06FF0-9 .]*$/;
  if (!value || regex.test(value)) {
    return null;
  }

  return "Valid characters include A-z, 0-9.";
};

const isOnlyNumbersSpacesAndLetters = value => {
  const regex = /^[a-zA-Z. \u0600-\u06FF0-9 .]*$/;
  if (!value || regex.test(value)) {
    return null;
  }

  return "Valid characters include A-z, 0-9.";
};

const onlyNumbersAndPlus = value => {
  const regex = /^[0-9+]*$/;
  if (!value || regex.test(value)) {
    return null;
  }

  return "Valid characters include 0-9.";
};

const isNotEmpty = value => {
  return value ? null : "This field is mandatory.";
};

const image = value => {
  if (!value && value !== 0 && value !== "0") return null;
  if (
    value.indexOf("data:image/jpeg") === -1 &&
    value.indexOf("data:image/jpg") === -1 &&
    value.indexOf("data:image/png") === -1
  ) {
    return "Valid formats are JPG and PNG.";
  }
  return null;
};

const onlyTenChars = value => {
  if (!value && value !== 0 && value !== "0") return null;
  if (value.length !== 10) {
    return "The number of characters should be 10.";
  } else {
    return null;
  }
};

const onlyTwelveCharsForMob = value => {
  if (!value && value !== 0 && value !== "0") return null;
  if (value.length !== 13) {
    return "The number of characters should be 12.";
  } else {
    return null;
  }
};

const atLeastSixChars = value => {
  if (!value && value !== 0 && value !== "0") return null;
  if (value.length < 6) {
    return "The number of characters should be at least 6.";
  } else {
    return null;
  }
};

const isOnlyNumbersAndDot = value => {
  const regex = /^[0-9.]+$/g;
  if (!value || regex.test(value)) {
    return null;
  }

  return "Valid characters include 0-9 and . character.";
};

const maxFiveDigit = value => {
  if (!value && value !== 0 && value !== "0") return null;
  if (Number(value) > 99999.99) {
    return "The maximum value should be a 5-digit number.";
  }
  return null;
};

const afterDecimalTwoChars = value => {
  if (!value && value !== 0 && value !== "0") return null;
  if (
    value.indexOf(".") > -1 &&
    value.substr(value.indexOf(".") + 1).length > 2
  ) {
    return "The maximum number of decimals should be 2.";
  }
  return null;
};

const year = value => {
  if (!value && value !== 0 && value !== "0") return null;

  const currentYear = new Date().getFullYear();
  const year = Number(value);
  const fromyear = 1970;
  if (year > currentYear || year < fromyear) {
    return "Valid range includes 1900 - current year.";
  }
  return null;
};

const tags = value => {
  if (value.hasOwnProperty("tags") && value.tags) {
    return null;
  }
  if (!value) return "error";
  let status = false;
  for (const key in value.tags) {
    if (value[key]) {
      status = true;
    }
  }
  if (status) {
    return null;
  }
  return "error";
};

const licensePlate = value => {
  if (!value && value !== 0 && value !== "0") return null;
  const regex = /^[a-zA-Z. \u0600-\u06FF]{3}\d{4}$/g;

  if (!value || regex.test(value)) {
    return null;
  }

  return "Valid format is 3 letters followed by 4 numbers.";
};

const notSpace = value => {
  const regex = /^[a-zA-Z0-9]*$/;
  if (!value || regex.test(value)) {
    return null;
  }

  return "Valid characters include A-z, 0-9.";
};

const valid = {
  email: isEmail,
  onlyText: isOnlyText,
  onlyNumbers: isOnlyNumbers,
  required: isNotEmpty,
  onlyNumbersAndLetters: isOnlyNumbersAndLatters,
  image: image,
  onlyTenChars: onlyTenChars,
  onlyTwelveCharsForMob: onlyTwelveCharsForMob,
  maxFiveDigit: maxFiveDigit,
  atLeastSixChars: atLeastSixChars,
  isOnlyNumbersAndDot: isOnlyNumbersAndDot,
  year: year,
  licensePlate: licensePlate,
  onlyNumbersAndPlus: onlyNumbersAndPlus,
  afterDecimalTwoChars: afterDecimalTwoChars,
  tags: tags,
  notSpace: notSpace,
  isOnlyNumbersSpacesAndLetters: isOnlyNumbersSpacesAndLetters
};



// WEBPACK FOOTER //
// ./src/utils/validation.js